var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { TextButton } from '@creditornot/cb-button';
import { MenuActionItem } from '@creditornot/cb-menu';
import { Popover } from '@creditornot/cb-popover';
import CaretDownIcon from './CaretDownIcon';
var noop = function () { };
var PopoverContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 8px;\n  overflow: hidden;\n  max-height: 320px;\n  min-width: 72px;\n  padding: 8px;\n"], ["\n  border-radius: 8px;\n  overflow: hidden;\n  max-height: 320px;\n  min-width: 72px;\n  padding: 8px;\n"])));
var PageSizesList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-y: auto;\n  max-height: 320px;\n"], ["\n  overflow-y: auto;\n  max-height: 320px;\n"])));
var StyledMenuActionItem = styled(MenuActionItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  & + & {\n    margin-top: 8px;\n  }\n"], ["\n  & + & {\n    margin-top: 8px;\n  }\n"])));
var PageSizeSelector = function (_a) {
    var className = _a.className, _b = _a.onChange, onChange = _b === void 0 ? noop : _b, options = _a.options, value = _a.value;
    return (React.createElement("div", { className: className },
        React.createElement(Popover, { content: function (_a) {
                var close = _a.close;
                return (React.createElement(PopoverContent, null,
                    React.createElement(PageSizesList, null, options.map(function (option) { return (React.createElement(StyledMenuActionItem, { key: option, onClick: function () {
                            close();
                            onChange(option);
                        }, selected: option === value, variant: "black" }, option)); }))));
            }, fallbackPlacements: ['top-end'], placement: "bottom-end" }, function (_a) {
            var refProps = _a.refProps;
            return (React.createElement(TextButton, __assign({}, refProps, { icon: React.createElement(CaretDownIcon, null), iconPosition: "right" }),
                "Show ",
                value));
        })));
};
export default PageSizeSelector;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=PageSizeSelector.js.map